import React from 'react';
import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import BreadcrumbNav from '@components/common/BreadcrumbNav/index.js';
import {HomeOutlined} from '@ant-design/icons';

function ServicePackageNav() {
    const {locale} = useRouter();

    return (
        <div>
            <BreadcrumbNav
                items={[
                    {label: '', href: '/', icon: <HomeOutlined />},
                    {
                        label: getLocaleContent(locale, 'page.service-package.breadcrumb-title'),
                        href: '/goi-dich-vu',
                        color: '#006940',
                    },
                ]}
            />
        </div>
    );
}

export default ServicePackageNav;
